export enum AyaKiddingMeFeatureFlags {
    LotusOneUrlReferencesNova = 'lotusone-url-references-nova'
}
